import JobQuoteCollapsible from './components/JobQuoteCollapsible';
import JobQuoteCompact from './components/JobQuoteCompact';
import JobQuoteFull from './components/JobQuoteFull';
import { useJobQuoteContext } from './context';

const JobQuoteContent: React.FunctionComponent = function () {
  const { variant } = useJobQuoteContext();
  if (variant === 'compact') return <JobQuoteCompact />;
  if (variant === 'collapsible') return <JobQuoteCollapsible />;
  return <JobQuoteFull />;
};

export default JobQuoteContent;
